// extracted by css-extract-rspack-plugin
export default {"wrapper":"_fd4c9eef","desktopSpacer":"_5c28a3d8","profileDataWrapper":"_da132394","nameWrapper":"_c0bf4f68","name":"_1f8ca23b","tabRow":"_512b5641"};